// extracted by mini-css-extract-plugin
export default {"login_wrapper":"Login_login_wrapper__wzSR+","link":"Login_link__8sRBm","active":"Login_active__j8qF2"};